import { ClaimDTO, RecallDTO, SalesOrderDTO, ViewVinRegistrationDTO } from 'src/services/generated/api.generated.v1';

export interface VehicleSalesOrders {
    vehicleUid: string,
    salesOrders: Array<SalesOrderDTO>
};

export interface VehicleClaims {
    vehicleUid: string,
    claims: Array<ClaimDTO>
};

export interface VehicleRecalls {
    vehicleUid: string,
    recalls: Array<RecallDTO>
};

export interface VehicleStateInterface {
    vinRegistrations: Array<ViewVinRegistrationDTO>,
    salesOrders: Array<VehicleSalesOrders>,
    claims: Array<VehicleClaims>,
    recalls: Array<VehicleRecalls>
};

function state(): VehicleStateInterface {
    return {
        vinRegistrations: [],
        salesOrders: [],
        claims: [],
        recalls: []
    }
};

export default state;